export enum ChatInstance {
  agentsPanel = 'agentsPanel',
  agentsPage = 'agentsPage',
  getStarted = 'getStarted',
  editPrompt = 'editPrompt',
}
